<template>
    <div class="searched-faq-list" v-if="ajaxDone" ref="searchedFaqScrollBox">
        <h1 class="search-key" v-text="$route.query.searchKey"></h1>
        <section class="faq-list box_search" :class="$style['box_search']" v-for="(faq, index) in AllFaqList" @click="viewFAQ(faq.KBInfoId, index)">
            <span class="search-item-title" v-html="faq.Title"></span>
            <div class="search-item-content"  v-html="faq.Content"></div>
            <div class="analyse-info">
                <span>{{ faq.TotalViewCount | validCount }}人浏览</span>
                <span class="ml-10">{{ faq.TotalCollectionCount | validCount }}人收藏</span>
            </div>
        </section>
        <div class="noData" v-if="!AllFaqList.length">暂无数据</div>
        <loading-more></loading-more>
    </div>
</template>

<script>
    import { SEARCH, COMMON } from '@/api'
    import loadingMore from '@/components/loadingMore'
    import store from '@/store/index'
    let routeFromSearch = false
    export default {
        name:'faqList',
        components:{loadingMore},
        data () {
            return {
                lastSearchKey:'',
                lastSearchNodeId:'',
                showBottomBar:false,
                ajaxDone:false,
                AllFaqList: [],
                pageIndex: 1,
                // pageSize: 15,
                pageSize: 100,
                pageCount: 1,
                prevAjaxEnd: true,
                scrollTop:0
            }
        },
        mounted() {
            this.initData()
            document.getElementById('search-page').addEventListener('scroll',this.scrollHandle,false)
        },
        activated(){
            document.getElementById('search-page').addEventListener('scroll',this.scrollHandle,false)
            document.getElementById('search-page').scrollTop = this.scrollTop
            if(this.$route.query.searchKey !== this.lastSearchKey || this.$route.query.searchNodeId !== this.lastSearchNodeId) {
                this.initData()
            }else{
                //是同一个搜索结果，再记录
                this.showBottomBar ? this.$store.commit('setBottomBar',this.showBottomBar) : this.$store.commit('setBottomBar','')
            }
        },
        methods: {
            initData () {
                this.showBottomBar = false
                this.lastSearchKey = this.$route.query.searchKey
                this.lastSearchNodeId = this.$route.query.searchNodeId
                this.scrollTop = 0
                this.ajaxDone = false

                this.AllFaqList = []
                this.pageIndex = 1
                this.pageCount = 1
                SEARCH.SearchingFaq({
                    Keywords: this.$route.query.searchKey,
                    NodeId: this.$route.query.searchNodeId,
                    PageIndex: this.pageIndex,
                    PageSize: this.pageSize
                }).then( (res) => {
                    this.AllFaqList = res.Data.List||[]
                    this.pageCount = Math.ceil(res.Data.TotalCount / this.pageSize)
                    this.ajaxDone = true;

                    // 如果有结果，延迟判断是否有滚动，如果没有滚动，就让底部提问栏渐显上来
                    let timer = setTimeout(()=>{
                        let windowH = document.getElementById('search-page').clientHeight;
                        let pageH = this.$refs.searchedFaqScrollBox.offsetHeight;

                        // 如果没有出现滚动
                        if(pageH <= windowH) {
                            this.$store.commit('setBottomBar','fade-up-delay');
                        }
                        clearTimeout(timer)
                    },1000)

                }).catch(()=>{
                    this.ajaxDone = true
                })
            },
            scrollHandle() {
                if(!this.$refs.searchedFaqScrollBox) return
                let windowH = document.getElementById('search-page').clientHeight;
                let pageH = this.$refs.searchedFaqScrollBox.offsetHeight;
                let windowScrollTop = document.getElementById('search-page').scrollTop;
                let leftTop = pageH - windowH - windowScrollTop;   //剩余高度(页面底部与视口底部的距离)

                // 如果剩余高度小于.18倍屏高 或者  滚动高度超过 .82倍屏高  不要问为什么是 0.18 ， 问就是sixsixsix
                if (leftTop < 0.18*windowH || windowScrollTop> 0.82*windowH) {
                    console.log(leftTop,windowH,pageH);
                    this.$store.commit('setBottomBar','slide-up');
                }
                if (leftTop <= 0) {
                    this.loadMore()
                }
            },
            loadMore () {
                if (!this.prevAjaxEnd) return
                if (this.pageIndex >= this.pageCount) return
                this.prevAjaxEnd = false
                store.commit('SET_LOADING_POSITION','bottom')
                SEARCH.SearchingFaq({
                    Keywords: this.$route.query.searchKey,
                    PageIndex: ++this.pageIndex,
                    PageSize: this.pageSize
                }).then( (res) => {
                    this.AllFaqList = this.AllFaqList.concat(res.Data.List)
                    this.$nextTick( () => {
                        this.prevAjaxEnd = true
                        store.commit('SET_LOADING_POSITION','middle')
                    })
                }).catch(()=>{
                    this.prevAjaxEnd = true
                    store.commit('SET_LOADING_POSITION','middle')
                })
            },
            viewFAQ(KBInfoId, numberIndex) {

                this.MovementsReport(KBInfoId, numberIndex)

                this.$router.push({
                    name: 'faq',
                    params: { uuid: KBInfoId }
                })
            },
            MovementsReport(KBInfoId, numberIndex) {

                if (!routeFromSearch) return

                COMMON.UpdateSearchMovementData({
                    LogId: this.$route.query.LogId,
                    clicknumber: numberIndex,
                    MovementEnum: 'MoreFAQ',
                    KBInfoId: KBInfoId
                }).then( (res) => {
                    resolve()
                })
            }

        },
        beforeRouteEnter(to, from, next) {
            if (from.name === 'searchKnowledge') {
                routeFromSearch = true
            }
            next()
        },
        beforeRouteLeave (to, from, next) {
            this.scrollTop = document.getElementById('search-page').scrollTop
            this.showBottomBar = this.$store.getters.bottomBar
            this.$store.commit('setBottomBar','')
            document.getElementById('search-page').removeEventListener('scroll', this.scrollHandle)
            next()
        },
        // watch:{
        //     '$route'(to, from) {
        //         if (to.name !== 'faqList') return
        //     }
        // }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .searched-faq-list {
        padding: 0 j(50);
        padding-bottom: j(180);
        .search-key {
            padding-top: j(36);
            margin-bottom: j(56);
            font-size: j(48);
            font-weight: 700;
            color: #363c54;
        }
        .faq-list {
            padding: j(40) 0;
            font-size: j(28);
            font-weight: 400;
            color: #363c54;
            word-break: break-word;
            position: relative;
            border-bottom: 1px solid #f1f2f3;
            &:last-child{
                border: none;
            }

        }
        .noData{
            width:100%;
            margin:0 auto;
            text-align:center;
            color:#ccc;
            font-size:j(30);
        }
        .search-item-title{
            font-size:j(28);
            color:#363C54;
            display:block;
        }
        .search-item-content{
            font-size:j(28);
            margin-top:j(20);
            color:#696D7F;

            overflow: hidden;
            text-overflow:ellipsis;
            word-break: break-word;
            display: -webkit-box;
            /*!autoprefixer: off */
            -webkit-box-orient: vertical;
            /*autoprefixer: on */
            -webkit-line-clamp: 2;
        }
        .analyse-info {
            margin-top: j(20);
            font-size: j(24);
            color: #9B9DA9;
        }
        .ml-10 {
            margin-left: 10px;
        }
    }

    @import "./animation.scss";

</style>


<style lang="scss" module>
    .box_search strong {
        color: #00bebe;
    }
</style>



// WEBPACK FOOTER //
// src/views/search/faqList.vue